import React, { useEffect } from 'react';
import { Scale } from 'lucide-react';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-3 mb-8">
          <Scale className="h-8 w-8 text-purple-400" />
          <h1 className="text-3xl font-bold gradient-text">Terms of Service</h1>
        </div>

        <div className="card p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">1. Acceptance of Terms</h2>
            <div className="space-y-4 text-gray-300">
              <p>By accessing and using TheMostUselessWebsite.com, you accept and agree to be bound by these Terms of Service.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">2. Description of Service</h2>
            <div className="space-y-4 text-gray-300">
              <p>TheMostUselessWebsite.com provides:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Entertainment content including useless facts, records, and inventions</li>
                <li>Daily challenges and achievements</li>
                <li>User progress tracking</li>
                <li>Social features including likes and sharing</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">3. User Accounts</h2>
            <div className="space-y-4 text-gray-300">
              <p>When creating an account, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information</li>
                <li>Maintain the security of your account</li>
                <li>Accept responsibility for all activities under your account</li>
                <li>Not share your account credentials</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">4. Acceptable Use</h2>
            <div className="space-y-4 text-gray-300">
              <p>You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use automated systems to interact with the website</li>
                <li>Attempt to manipulate achievement or like systems</li>
                <li>Engage in any activity that disrupts the service</li>
                <li>Share inappropriate or harmful content</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">5. Intellectual Property</h2>
            <div className="space-y-4 text-gray-300">
              <p>All content on TheMostUselessWebsite.com is protected by copyright and other intellectual property rights. You may not reproduce, distribute, or create derivative works without our permission.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">6. Termination</h2>
            <div className="space-y-4 text-gray-300">
              <p>We reserve the right to terminate or suspend access to our service immediately, without prior notice, for any violation of these Terms.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">7. Disclaimer</h2>
            <div className="space-y-4 text-gray-300">
              <p>The content provided is for entertainment purposes only. We make no warranties about the accuracy or reliability of the content.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">8. Changes to Terms</h2>
            <div className="space-y-4 text-gray-300">
              <p>We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of modified terms.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;